import { useEffect, useRef, useState } from "react";

export type ToastType = {
  content: string;
  success?: boolean;
  warning?: boolean;
  error?: boolean;
  info?: boolean;
  timeout?: number;
};

export interface ToastContextData {
  toast: ToastType | undefined;
  showSuccess: (content: string, timeout?: number) => void;
  showError: (error: any, content: string, timeout?: number) => void;
  setToast: (toast?: ToastType) => void;
}

export const InitialToastContextData: ToastContextData = {
  toast: undefined,
  showSuccess: () => {},
  showError: () => {},
  setToast: () => {},
};

export const ToastContext = (): ToastContextData => {
  const [toast, setToast] = useState<ToastType>();

  const showSuccess = (content: string, timeout?: number) => {
    setToast({
      content,
      success: true,
      timeout,
    });
  };

  const showError = (error: any, content: string, timeout?: number) => {
    console.error(error);
    setToast({
      content,
      error: true,
      timeout,
    });
  };

  const clearToastTimeout = useRef<ReturnType<typeof setTimeout> | undefined>();

  useEffect(() => {
    if (clearToastTimeout.current) {
      clearTimeout(clearToastTimeout.current);
      clearToastTimeout.current = undefined;
    }
    if (toast) {
      clearToastTimeout.current = setTimeout(() => {
        clearToastTimeout.current = undefined;
        setToast(undefined);
      }, toast.timeout || 3000);
    }
  }, [toast]);

  return {
    toast,
    showSuccess,
    showError,
    setToast,
  };
};
